import { render, staticRenderFns } from "./EditButton.vue?vue&type=template&id=5588d959"
import script from "./EditButton.vue?vue&type=script&lang=ts"
export * from "./EditButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5588d959')) {
      api.createRecord('5588d959', component.options)
    } else {
      api.reload('5588d959', component.options)
    }
    module.hot.accept("./EditButton.vue?vue&type=template&id=5588d959", function () {
      api.rerender('5588d959', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/CarePlanRightSide/components/EditButton.vue"
export default component.exports